(() => {
  const WHATSAPP_PHONE = '5564999480738';
  const BUTTON_LABEL = 'Enviar pedido no WhatsApp';

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getOrderNote() {
    const noteField = document.querySelector(
      'textarea[name="note"], textarea#Cart-note, textarea[id*="note"], textarea[name*="note"]'
    );

    return cleanText(noteField?.value || '');
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Não foi possível consultar o carrinho.');
    }

    return response.json();
  }

  function buildWhatsAppMessage(cart) {
    const items = Array.isArray(cart.items) ? cart.items : [];

    const itemLines = items.map((item, index) => {
      const productName = cleanText(item.product_title || item.title || 'Produto');
      const variantTitle =
        item.variant_title && item.variant_title !== 'Default Title'
          ? ` - ${cleanText(item.variant_title)}`
          : '';

      return `${index + 1}. ${productName}${variantTitle}\n   Quantidade: ${item.quantity}`;
    });

    const note = getOrderNote();

    let message = `Olá! Quero solicitar um pedido/orçamento na Natucopos.\n\n`;
    message += `Itens selecionados:\n${itemLines.join('\n\n')}`;

    if (note) {
      message += `\n\nObservações do pedido:\n${note}`;
    }

    message += `\n\nPodem me orientar sobre os proxímos passos?`;

    return message;
  }

  function openWhatsApp(message) {
    const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;
  }

  async function handleWhatsAppCheckout(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const originalText = button.tagName === 'INPUT' ? button.value : button.textContent;

    try {
      if (button.tagName === 'INPUT') {
        button.value = 'Gerando pedido...';
      } else {
        button.textContent = 'Gerando pedido...';
      }

      button.disabled = true;

      const cart = await getCart();

      if (!cart.items || cart.items.length === 0) {
        alert('Seu pedido está vazio. Adicione pelo menos um produto antes de enviar.');
        return;
      }

      const message = buildWhatsAppMessage(cart);
      openWhatsApp(message);
    } catch (error) {
      console.error(error);
      alert('Não foi possível preparar o pedido. Tente novamente.');
    } finally {
      button.disabled = false;

      if (button.tagName === 'INPUT') {
        button.value = originalText;
      } else {
        button.textContent = originalText;
      }
    }
  }

  function convertCheckoutButtons() {
    const selectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href*="/checkout"]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((button) => {
      if (button.dataset.natucoposWhatsappReady === 'true') return;

      button.dataset.natucoposWhatsappReady = 'true';

      if (button.tagName === 'INPUT') {
        button.value = BUTTON_LABEL;
      } else {
        button.textContent = BUTTON_LABEL;
      }

      if (button.tagName === 'BUTTON') {
        button.type = 'button';
        button.removeAttribute('name');
      }

      if (button.tagName === 'A') {
        button.removeAttribute('href');
        button.setAttribute('role', 'button');
      }

      button.setAttribute('aria-label', BUTTON_LABEL);
      button.addEventListener('click', handleWhatsAppCheckout, true);
    });
  }

  document.addEventListener('DOMContentLoaded', convertCheckoutButtons);
  document.addEventListener('shopify:section:load', convertCheckoutButtons);

  const observer = new MutationObserver(() => {
    convertCheckoutButtons();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();